import * as types from "./types";

export function getDashboardInfoStart() {
	return {
		type: types.GET_DASHBOARD_INFO_START,
	};
}
export function getDashboardInfoSuccess(res?: any) {
	return {
		type: types.GET_DASHBOARD_INFO_SUCCESS,
		payload: res,
	};
}
export function getDashboardInfoError(e: any) {
	return {
		type: types.GET_DASHBOARD_INFO_ERROR,
		payload: e,
	};
}

export function getCertificatesStart() {
	return {
		type: types.GET_CERTIFICATES_START,
	};
}
export function getCertificatesSuccess(res?: any) {
	return {
		type: types.GET_CERTIFICATES_SUCCESS,
		payload: res,
	};
}
export function getCertificatesError(e: any) {
	return {
		type: types.GET_CERTIFICATES_ERROR,
		payload: e,
	};
}
export function updateRecipientStart() {
	return {
		type: types.UPDATE_RECIPIENT_START,
	};
}
export function updateRecipientSuccess(res?: any) {
	return {
		type: types.UPDATE_RECIPIENT_SUCCESS,
		payload: res,
	};
}
export function updateRecipientError(e: any) {
	return {
		type: types.UPDATE_RECIPIENT_ERROR,
		payload: e,
	};
}
// export function getCommunicationsStart() {
//   return {
//     type: types.GET_COMMUNICATIONS_START
//   };
// }
// export function getCommunicationsSuccess(res?: any) {
//   return {
//     type: types.GET_COMMUNICATIONS_SUCCESS,
//     payload: res
//   };
// }
// export function getCommunicationsError(e: any) {
//   return {
//     type: types.GET_COMMUNICATIONS_ERROR,
//     payload: e
//   };
// }

export function setWizzardActiveStep(stepNumber: number) {
	return {
		type: types.SET_WIZZARD_ACTIVE_STEP,
		payload: stepNumber,
	};
}

// Toaster component
let id = 0;
const defaultOptions = {
	color: "#6796e6",
};
export default function createToast(options: any) {
	return {
		...defaultOptions,
		...options,
		id: id++,
	};
}
export function addToast(toast: any) {
	return {
		type: types.ADD_TOAST,
		payload: createToast(toast),
	};
}
export function clearToasts() {
	return {
		type: types.CLEAR_TOASTS,
	};
}

export function removeToast(toast: any) {
	return {
		type: types.REMOVE_TOAST,
		payload: toast,
	};
}
